// Shared ad coordinator for the home feed.
//
// The feed-data edge function returns a single shuffled pool of sponsored ads
// on the first page. Every ad slot on the page — feed posts and story slides —
// draws from that pool through `nextAd()`, advancing one shared cursor. That
// means no ad repeats until the entire pool has been shown, at which point the
// cycle wraps around. Seeding happens once per page load (from feed.adPool)
// so every consumer on the page sees the same ordering.

let pool = [];
let cursor = 0;

/**
 * Seed (or refresh) the shuffled ad pool. Called once when the first page of
 * feed data arrives. Empty/absent pools are ignored so a later page without a
 * pool doesn't clobber the ordering already in use.
 * @param {Array|undefined} ads The shuffled sponsored-ad objects.
 */
export function seedAds(ads) {
  if (Array.isArray(ads) && ads.length) {
    pool = ads;
    cursor = 0;
  }
}

/**
 * Return the next ad from the shared pool. Advances the shared cursor so feed
 * and story ad slots never get the same ad before the pool is exhausted.
 * Returns null when there are no sponsored ads.
 * @returns {object|null}
 */
export function nextAd() {
  if (!pool.length) return null;
  const ad = pool[cursor % pool.length];
  cursor += 1;
  return ad;
}